namespace $.$$ {
	$mol_style_define($bog_formigo_submissions, {
		Body_content: {
			padding: $mol_gap.block,
		},
	})
}
